// /fisUsers 검색 필드 정의 (SearchToolbar config).
// 기존 인라인 <TextField> 5개를 이 배열 하나로 대체한다. field 키 / operator / 옵션값 동일.

import type { SearchFieldConfig } from "components/list";

export const fisUsersSearchFields: SearchFieldConfig[] = [
  { name: "id", label: "ID", type: "text", operator: "contains", width: 140 },
  { name: "name", label: "이름", type: "text", operator: "contains", width: 200 },
  { name: "loginId", label: "로그인ID", type: "text", operator: "contains", width: 200 },
  {
    name: "auth",
    label: "권한",
    type: "select",
    operator: "eq",
    width: 160,
    options: [
      { value: "", label: "전체" },
      { value: "ADMIN", label: "어드민" },
      { value: "MANAGER", label: "관리자" },
      { value: "USER", label: "콜요원" },
      { value: "AGENT", label: "현장요원" },
      { value: "FIRED", label: "퇴사" },
    ],
  },
  { name: "phoneNumber", label: "전화번호", type: "text", operator: "contains", width: 200 },
];
